angular.module("UI8.components").component("userProfile", {
  template: `<div class="profile" ng-if="$ctrl.data">
    <div class="profile__header">
      <div class="profile__container container">
        <div class="profile__inner">
          <div class="profile__avatar" ui8-avatar="$ctrl.data.profile"></div>
          <div class="profile__details">
            <div class="profile__line">
              <h1 class="profile__name" ng-if="$ctrl.data.profile.display_name">{{ $ctrl.data.profile.display_name }}</h1>
              <h1 class="profile__name" ng-if="!$ctrl.data.profile.display_name">{{ $ctrl.data.profile.first_name }} {{ $ctrl.data.profile.last_name }}</h1>
              <div class="profile__role profile__badge--admin" ng-if="$ctrl.data.profile.role === 'admin' && $ctrl.data.profile.display_name !== 'UI8'">Admin</div>
              <div class="profile__role" ng-if="$ctrl.data.products">Author</div>
              <div class="profile__role profile__role--hire" ng-if="$ctrl.data.hire.badge === 'founding'">Founding Member</div>
              <div class="profile__role profile__role--hire" ng-if="$ctrl.data.hire.badge === 'verified'">Verified</div>
              <div class="profile__role profile__role--follow" ng-if="$ctrl.data.follows_you">Follows you</div>
            </div>
            <div class="profile__bio" ng-bind="$ctrl.data.profile.biography"></div>
            <div class="profile__links ng-cloak" ng-if="$ctrl.hasLinks">
              <span class="profile__location" ng-if="$ctrl.data.profile.location">
                <svg class="is-stroke" viewBox="0 0 24 24"><path d="M12 21s7-5.5 7-11.5a7 7 0 1 0-14 0C5 15.5 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>
                {{ $ctrl.data.profile.location }}
              </span>
              <a class="profile__site" ng-if="$ctrl.links.website" ng-href="{{$ctrl.links.website}}" target="_blank" rel="nofollow noopener">
                <svg class="is-stroke" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.4 3.75 5.4 3.75 9S14.5 18.6 12 21c-2.5-2.4-3.75-5.4-3.75-9S9.5 5.4 12 3z"/></svg>
                <span>{{ $ctrl.links.websiteLabel }}</span>
              </a>
              <span class="profile__socials">
                <a class="profile__social" ng-if="$ctrl.links.instagram" ng-href="{{$ctrl.links.instagram}}" target="_blank" rel="nofollow noopener" aria-label="Instagram">
                  <svg class="is-stroke" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><path d="M17.2 6.8h.01"/></svg>
                </a>
                <a class="profile__social" ng-if="$ctrl.links.twitter" ng-href="{{$ctrl.links.twitter}}" target="_blank" rel="nofollow noopener" aria-label="X (Twitter)">
                  <svg viewBox="0 0 24 24"><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/></svg>
                </a>
                <a class="profile__social" ng-if="$ctrl.links.dribbble" ng-href="{{$ctrl.links.dribbble}}" target="_blank" rel="nofollow noopener" aria-label="Dribbble">
                  <svg viewBox="0 0 24 24"><path d="M12 24C5.385 24 0 18.615 0 12S5.385 0 12 0s12 5.385 12 12-5.385 12-12 12zm10.12-10.358c-.35-.11-3.17-.953-6.384-.438 1.34 3.684 1.887 6.684 1.992 7.308 2.3-1.555 3.936-4.02 4.395-6.87zm-6.115 7.808c-.153-.9-.75-4.032-2.19-7.77l-.066.02c-5.79 2.015-7.86 6.025-8.04 6.4 1.73 1.358 3.92 2.166 6.29 2.166 1.42 0 2.77-.29 4-.814zm-11.62-2.58c.232-.4 3.045-5.055 8.332-6.765.135-.045.27-.084.405-.12-.26-.585-.54-1.167-.832-1.74C7.17 11.775 2.206 11.71 1.756 11.7l-.004.312c0 2.633.998 5.037 2.634 6.855zm-2.42-8.955c.46.008 4.683.026 9.477-1.248-1.698-3.018-3.53-5.558-3.8-5.928-2.868 1.35-5.01 3.99-5.676 7.17zM9.6 2.052c.282.38 2.145 2.914 3.822 6 3.645-1.365 5.19-3.44 5.373-3.702-1.81-1.61-4.19-2.586-6.795-2.586-.825 0-1.63.1-2.4.285zm10.335 3.483c-.218.29-1.935 2.493-5.724 4.04.24.49.47.985.68 1.486.08.18.15.36.22.53 3.41-.43 6.8.26 7.14.33-.02-2.42-.88-4.64-2.31-6.38z"/></svg>
                </a>
                <a class="profile__social" ng-if="$ctrl.links.behance" ng-href="{{$ctrl.links.behance}}" target="_blank" rel="nofollow noopener" aria-label="Behance">
                  <svg viewBox="0 0 24 24"><path d="M6.938 4.503c.702 0 1.34.06 1.92.188.577.13 1.07.33 1.485.61.41.28.733.65.96 1.12.225.47.34 1.05.34 1.73 0 .74-.17 1.36-.507 1.86-.338.5-.837.9-1.502 1.22.906.26 1.576.72 2.022 1.37.448.66.665 1.45.665 2.36 0 .75-.13 1.39-.41 1.93-.28.55-.67 1-1.16 1.35-.48.348-1.05.6-1.67.767-.61.165-1.252.254-1.91.254H0V4.51h6.938v-.007zm-.194 5.947c.574 0 1.05-.134 1.425-.412.374-.27.554-.72.554-1.34 0-.35-.064-.635-.185-.853-.128-.22-.293-.39-.51-.512-.21-.124-.45-.21-.72-.257-.27-.053-.56-.075-.845-.075H3.24v3.45h3.504zm.194 6.24c.325 0 .64-.03.93-.094.29-.06.55-.165.765-.31.22-.146.39-.34.52-.583.13-.24.19-.57.19-.96 0-.75-.22-1.29-.64-1.62-.43-.32-1.01-.48-1.69-.48H3.24v4.05h3.698zm9.882-.025c.44.428 1.073.643 1.894.643.59 0 1.1-.148 1.53-.447.424-.29.68-.61.78-.94h2.588c-.403 1.28-1.048 2.2-1.9 2.75-.85.56-1.884.83-3.08.83-.837 0-1.584-.13-2.272-.4-.673-.27-1.24-.65-1.72-1.14-.464-.49-.823-1.08-1.077-1.77-.253-.69-.373-1.45-.373-2.27 0-.803.135-1.54.403-2.23.27-.7.644-1.28 1.12-1.79.495-.51 1.063-.895 1.736-1.194s1.4-.433 2.22-.433c.91 0 1.69.164 2.38.523.68.34 1.23.82 1.65 1.4.42.586.72 1.26.9 2.02.195.75.255 1.54.225 2.36h-7.69c0 .84.28 1.632.71 2.065l-.024.045zm3.32-5.554c-.35-.393-.934-.602-1.643-.602-.46 0-.85.08-1.16.23-.31.15-.55.34-.74.57-.19.23-.32.48-.4.75-.08.26-.13.5-.14.71h4.88c-.07-.75-.34-1.31-.79-1.66h-.007zm-4.44-4.68h6.03v1.47h-6.03V6.43z"/></svg>
                </a>
                <a class="profile__social" ng-if="$ctrl.links.linkedin" ng-href="{{$ctrl.links.linkedin}}" target="_blank" rel="nofollow noopener" aria-label="LinkedIn">
                  <svg viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div class="profile__actions">
          <div class="profile__group ng-cloak">
            <button class="btn btn--stroke" ng-class="{active: $ctrl.tab === 'products'}" ng-if="$ctrl.data.products && $ctrl.data.products.length" ng-click="$ctrl.selectTab('products')">
              Products
              <span>{{ $ctrl.data.productCount || 0 }}</span>
            </button>
            <button class="btn btn--stroke" ng-class="{active: $ctrl.tab === 'shots'}" ng-if="$ctrl.data.shotsCount" ng-click="$ctrl.selectTab('shots')">
              Work
              <span>{{ $ctrl.data.shotsCount || 0 }}</span>
            </button>
            <button class="btn btn--stroke" ng-class="{active: $ctrl.tab === 'followers'}" ng-if="$ctrl.data.profile.followers_sum !== 0" ng-click="$ctrl.selectTab('followers')">
              Followers
              <span>{{ $ctrl.data.profile.followers_sum || 0 }}</span>
            </button>
            <button class="btn btn--stroke" ng-class="{active: $ctrl.tab === 'following'}" ng-if="$ctrl.data.profile.following_sum !== 0" ng-click="$ctrl.selectTab('following')">
              Following
              <span>{{ $ctrl.data.profile.following_sum || 0 }}</span>
            </button>
            <button class="btn btn--stroke" ng-class="{active: $ctrl.tab === 'favorites'}" ng-if="$ctrl.data.profile.favorites_sum !== 0" ng-click="$ctrl.selectTab('favorites')">
              Favorites
              <span>{{ $ctrl.data.profile.favorites_sum || 0 }}</span>
            </button>
          </div>
          <div class="profile__group">
            <a class="btn btn--green" ng-if="!$ctrl.user && $ctrl.data.hire.available" href="/account/signup">Hire</a>
            <button class="btn btn--green" ng-if="$ctrl.user && !$ctrl.ownProfile && $ctrl.data.hire.available" ui8-hire-button ui8-track-event="Open Hire Modal">Hire</button>
            <a class="btn btn--stroke" ng-if="$ctrl.isAdmin" ng-href="/admin/users/{{$ctrl.data.profile._id}}">View in admin</a>
            <button class="btn" ng-if="$ctrl.user && !$ctrl.ownProfile" ui8-follow-button="{{$ctrl.data.profile._id}}">Follow</button>
            <a class="btn" ng-if="!$ctrl.user && !$ctrl.ownProfile" href="/account/signup">Follow</a>
            <a class="btn btn--stroke" ng-if="$ctrl.user && $ctrl.ownProfile" href="/account/settings">Edit profile</a>
          </div>
        </div>
      </div>
    </div>
    <div class="profile__body">
      <div class="container">
        <div ng-if="$ctrl.tab === 'followers'">
          <div class="profile__message" ng-if="!$ctrl.data.profile.followers_sum">
            {{ $ctrl.ownProfile ? 'You do not' : 'This user does not' }} have any followers yet, here are some of our top designers...
          </div>
          <div class="users" ng-if="$ctrl.followers">
            <div class="users__inner">
              <div class="users__list">
                <list-user ng-repeat="f in $ctrl.followers track by $index" ng-hide="!f" profile="f" user="$ctrl.user"></list-user>
              </div>
            </div>
            <div class="users__foot" ng-if="$ctrl.followers.length < $ctrl.data.profile.followers_sum">
              <button class="btn btn--stroke" ng-click="$ctrl.moreFollowers()">Load more</button>
            </div>
          </div>
        </div>
        <div ng-if="$ctrl.tab === 'following'">
          <div class="profile__message" ng-if="!$ctrl.data.profile.following_sum">
            {{ $ctrl.ownProfile ? 'You are' : 'This user is' }} not following anyone yet, here are some of our top designers...
          </div>
          <div class="users" ng-if="$ctrl.following">
            <div class="users__inner">
              <div class="users__list">
                <list-user ng-repeat="f in $ctrl.following track by $index" profile="f" user="$ctrl.user"></list-user>
              </div>
            </div>
            <div class="users__foot" ng-if="$ctrl.following.length < $ctrl.data.profile.following_sum">
              <button class="btn btn--stroke" ng-click="$ctrl.moreFollowing()">Load more</button>
            </div>
          </div>
        </div>
        <div ng-if="$ctrl.data.favorites && $ctrl.tab === 'favorites'">
          <div class="profile__message" ng-if="!$ctrl.data.favoritesCount">
            {{ $ctrl.ownProfile ? 'You do not' : 'This user does not' }} have any favorites yet, here are some of our most popular products...
          </div>
          <div class="profile__catalog catalog">
            <product-card ng-repeat="product in $ctrl.data.favorites track by $index" product="product" user="$ctrl.user"></product-card>
          </div>
          <div class="profile__foot" ng-if="$ctrl.data.favorites.length < $ctrl.data.favoritesCount">
            <button class="btn" ng-if="!$ctrl.loading" ng-click="$ctrl.moreFavorites()">Load more</button>
            <div class="loader loader--small" ng-if="$ctrl.loading"></div>
          </div>
        </div>
        <div ng-if="$ctrl.data.products && $ctrl.tab === 'products'">
          <div class="profile__catalog catalog">
            <product-card ng-repeat="product in $ctrl.data.products track by $index" product="product" user="$ctrl.user" link-query="'?browse=author'"></product-card>
          </div>
          <div class="profile__foot" ng-if="$ctrl.data.products.length < $ctrl.data.productCount">
            <button class="btn" ng-if="!$ctrl.loading" ng-click="$ctrl.moreProducts()">Load more</button>
            <div class="loader loader--small" ng-if="$ctrl.loading"></div>
          </div>
        </div>
        <div ng-if="$ctrl.data.shots && $ctrl.tab === 'shots'">
          <div class="profile__shots shots__grid">
            <shot-card ng-repeat="shot in $ctrl.data.shots track by shot._id" shot="shot" user="$ctrl.user"></shot-card>
          </div>
          <div class="profile__foot" ng-if="$ctrl.data.shots.length < $ctrl.data.shotsCount">
            <button class="btn" ng-if="!$ctrl.loading" ng-click="$ctrl.moreShots()">Load more</button>
            <div class="loader loader--small" ng-if="$ctrl.loading"></div>
          </div>
        </div>
      </div>
    </div>
    <hire-modal ng-if='$ctrl.data.hire.available' author='$ctrl.data.profile' success='$ctrl.hire_message_success'></hire-modal>
  </div>
  <div class="spage" ng-if="!$ctrl.data">
    <div class="spage__background">
      <img src="/img/404.jpg" alt="Oops!">
    </div>
    <div class="spage__container">
      <a href="/" class="spage__logo ui8-logo"></a>
      <div class="spage__title">Oops!</div>
      <div class="spage__content">The user you’re looking for no longer exists.</div>
      <a href="/" class="btn btn--submit">Go to homepage</a>
    </div>
    <div class="spage__copyright">© 2026, Robot Global FZCO / UI8.NET</div>
  </div>`,

  controller: function (UserService, ProductService, ShotService) {
    var ctrl = this;

    ctrl.$onInit = function () {
      // if (ctrl.data.profile.private_profile) {
      //   ctrl.private = true;
      //   return;
      // }

      // if (ctrl.data.profile.not_found) {
      //   ctrl.not_found = true;
      //   return;
      // }

      if (!ctrl.data.profile.biography)
        ctrl.data.profile.biography = "I haven&apos;t changed my bio yet!";

      ctrl.followersPage = 1;
      ctrl.followingPage = 1;
      ctrl.productsPage = 1;
      ctrl.favoritesPage = 1;
      ctrl.shotsPage = 1;

      ctrl.ownProfile = ctrl.user
        ? ctrl.data.profile._id === ctrl.user._id
        : false;

      // Admins get a shortcut to this account's admin page
      ctrl.isAdmin = !!(window.UI8 && window.UI8.userIsAdmin);

      buildLinks();

      var urlParams = new URLSearchParams(window.location.search);
      var hashCollection = /#([a-z]+)/i.exec(window.location.hash);
      var hashValue =
        hashCollection && Array.isArray(hashCollection) && hashCollection[1];
      var hasProducts = ctrl.data.products && ctrl.data.products.length;
      var hasShots = ctrl.data.shots && ctrl.data.shots.length;

      switch (hashValue) {
        case "favorites":
          ctrl.tab = "favorites";
          break;
        case "followers":
          ctrl.tab = "followers";
          break;
        case "following":
          ctrl.tab = "following";
          break;
        case "shots":
          ctrl.tab = "shots";
          break;
        default:
          // Work leads when someone has shots but nothing for sale
          ctrl.tab = hasProducts
            ? "products"
            : hasShots
            ? "shots"
            : "favorites";
          break;
      }
      ctrl.selectTab(ctrl.tab);

      if (urlParams.has("success")) {
        ctrl.hire_message_success = parseInt(urlParams.get("success"));
        $("body").addClass("hire-modal");
      }
    };

    // Same normalization as helpers/profile-fields.js cleanHandle — also
    // covers legacy free-text instagram values that predate sanitization
    function cleanHandle(raw) {
      if (!raw) return "";
      return String(raw)
        .trim()
        .replace(/^https?:\/\/(www\.)?[^/]+\//i, "")
        .replace(/^@/, "")
        .replace(/[?#].*$/, "")
        .replace(/\/+$/, "")
        .replace(/[^\w.\-/]/g, "")
        .slice(0, 60);
    }

    function buildLinks() {
      var p = ctrl.data.profile;
      var instagram = cleanHandle(p.instagram);
      var twitter = cleanHandle(p.twitter_x);
      var dribbble = cleanHandle(p.dribbble);
      var behance = cleanHandle(p.behance);
      var linkedin = cleanHandle(p.linkedin);
      var website = /^https?:\/\//i.test(p.website_url || "")
        ? p.website_url
        : null;

      ctrl.links = {
        website: website,
        websiteLabel: (website || "")
          .replace(/^https?:\/\/(www\.)?/i, "")
          .replace(/\/$/, ""),
        instagram: instagram ? "https://instagram.com/" + instagram : null,
        twitter: twitter ? "https://x.com/" + twitter : null,
        dribbble: dribbble ? "https://dribbble.com/" + dribbble : null,
        behance: behance ? "https://www.behance.net/" + behance : null,
        linkedin: linkedin
          ? "https://www.linkedin.com/" +
            (linkedin.indexOf("/") !== -1 ? linkedin : "in/" + linkedin)
          : null,
      };

      ctrl.hasLinks = !!(
        p.location ||
        ctrl.links.website ||
        ctrl.links.instagram ||
        ctrl.links.twitter ||
        ctrl.links.dribbble ||
        ctrl.links.behance ||
        ctrl.links.linkedin
      );
    }

    // Followers, following and (on author profiles) favorites are fetched
    // when their tab opens rather than resolved before first paint; the
    // profile used to wait on three extra round trips it rarely showed.
    ctrl.selectTab = function (name) {
      ctrl.tab = name;
      var id = ctrl.data.profile._id;

      if (name === "followers" && !ctrl.followers && !ctrl.followersLoading) {
        ctrl.followersLoading = true;
        UserService.followers(id).then(function (response) {
          ctrl.followers = response || [];
          ctrl.followersLoading = false;
        });
      }

      if (name === "following" && !ctrl.following && !ctrl.followingLoading) {
        ctrl.followingLoading = true;
        UserService.following(id).then(function (response) {
          ctrl.following = response || [];
          ctrl.followingLoading = false;
        });
      }

      if (
        name === "favorites" &&
        !ctrl.data.favorites &&
        !ctrl.favoritesLoading
      ) {
        ctrl.favoritesLoading = true;
        UserService.favorites(id, 1).then(function (response) {
          ctrl.data.favorites = response || [];
          ctrl.favoritesLoading = false;
        });
      }
    };

    ctrl.moreFollowers = function () {
      ctrl.followersPage += 1;
      UserService.followers(ctrl.data.profile._id, ctrl.followersPage).then(
        function (response) {
          ctrl.followers = ctrl.followers.concat(response);
        }
      );
    };

    ctrl.moreFollowing = function () {
      ctrl.followingPage += 1;
      UserService.following(ctrl.data.profile._id, ctrl.followingPage).then(
        function (response) {
          ctrl.following = ctrl.following.concat(response);
        }
      );
    };

    ctrl.moreProducts = function () {
      ctrl.loading = true;
      ctrl.productsPage += 1;
      ProductService.list({
        author: ctrl.data.profile._id,
        sort: "authorDefined",
        page: ctrl.productsPage,
        include_freebies: true,
      })
        .then(function (response) {
          ctrl.loading = false;
          ctrl.data.products = ctrl.data.products.concat(response.products);
          if (response.products.length < 24)
            ctrl.data.productCount = ctrl.data.products.length;
        })
        .catch(function () {
          ctrl.loading = false;
        });
    };

    ctrl.moreShots = function () {
      ctrl.loading = true;
      ctrl.shotsPage += 1;
      ShotService.listByUser(ctrl.data.profile._id, ctrl.shotsPage)
        .then(function (response) {
          ctrl.loading = false;
          ctrl.data.shots = ctrl.data.shots.concat(response.shots);
        })
        .catch(function () {
          ctrl.loading = false;
        });
    };

    ctrl.moreFavorites = function () {
      ctrl.loading = true;
      ctrl.favoritesPage += 1;
      UserService.favorites(ctrl.data.profile._id, ctrl.favoritesPage)
        .then(function (response) {
          ctrl.loading = false;
          ctrl.data.favorites = ctrl.data.favorites.concat(response);
          if (response.length < 48)
            ctrl.data.favoritesCount = ctrl.data.favorites.length;
        })
        .catch(function () {
          ctrl.loading = false;
        });
    };
  },

  bindings: {
    data: "<",
    user: "<",
  },
});
